import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { TipoABM } from '../../interfaces/tipo-abm';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TipoForm } from '../../interfaces/tipo-form';
import { OtService } from '../../providers/ot.service';
import { ComunicacionService } from '../../providers/comunicacion.service';
import { UploaderComponent } from '../../components/archivo/uploader/uploader.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AccesorioService } from '../../providers/accesorio.service';
import { ProductoService } from '../../providers/producto.service';
import { CaracteristicaService } from '../../providers/caracteristica.service';
import { PermisoService } from '../../providers/permiso.service';
import { DownloaderComponent } from '../../components/archivo/downloader/downloader.component';

@Component({
  selector: 'app-ot',
  templateUrl: './ot.component.html',
  styleUrls: ['./ot.component.scss']
})
export class OtComponent implements OnInit, AfterViewInit {
  productos: any[] = [];
  readonly CANTIDAD_MAXIMA_PRODUCTO_POR_OT = 1;
  TipoForm: TipoForm = new TipoForm();
  TipoABM: TipoABM = new TipoABM();
  tipoABM: string;
  tipoForm: string;
  titulo: string;
  cargando: boolean[];
  model: any;
  form = this._fb.group({
    id: [null],
    numero: [null],
    fecha_vigencia: [null],
    fecha_entrega: [null],
    archivos: [[]],
    // para más de un producto,
    // los campos de acá para abajo van en un array
    especial: [false, Validators.required],
    producto: [null, Validators.required],
    cantidad: [1, [Validators.required, Validators.min(1)]],
    CUT: [{ value: null, disabled: true }],
    producto_descripcion: [null],
    accesorios: this._fb.array([]),
    especificacion_tecnica_archivo_id: [[]],
    pdtg_archivo_id: [[]],
    esquema_dimensiones_archivo_id: [[]],
    observaciones: [''],
    caracteristicas: this._fb.array([]),
    revision: [7],
    multas: [false, Validators.required],
  });
  @ViewChild('uploader') uploader: UploaderComponent;
  @ViewChild('uploaderPDTG') uploaderPDTG: UploaderComponent;
  @ViewChild('uploaderEspecificacionTecnica') uploaderEspecificacionTecnica: UploaderComponent;
  @ViewChild('uploaderEsquemaDimensiones') uploaderEsquemaDimensiones: UploaderComponent;
  @ViewChild('downloader') downloader: DownloaderComponent;
  @ViewChild('downloaderPDTG') downloaderPDTG: DownloaderComponent;
  @ViewChild('downloaderEspecificacionTecnica') downloaderEspecificacionTecnica: DownloaderComponent;
  @ViewChild('downloaderEsquemaDimensiones') downloaderEsquemaDimensiones: DownloaderComponent;
  @ViewChild('ngSelectProducto') private _ngSelectProducto: NgSelectComponent;
  readonly fechas_de_entrega = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360];
  private _producto_id: number;
  // si cambia el selector de producto
  set producto_id(value: number) {
    this._producto_id = value;
    const producto = this.productos.find(producto => producto.IdProducto == this.producto_id);
    // set producto
    this.form.controls.producto.setValue(producto);
    if (producto && producto.ProductoCUT)
      this.form.get('CUT').setValue(producto.ProductoCUT);
    // clear accesorios (cambian según el accesorio, hay que volver a seleccionarlos)
    this.form.controls.accesorios = this._fb.array([]);
    // actualizar listado de accesorios
    this._traerAccesorios();
  }
  get producto_id(): number {
    return this._producto_id;
  }

  get accesorios() {
    return (this.form.get('accesorios') as FormArray);
  }

  get caracteristicas() {
    return (this.form.get('caracteristicas') as FormArray);
  }

  constructor(
    private _dialogRef: MatDialogRef<OtComponent>,
    @Inject(MAT_DIALOG_DATA) private _data,
    private _fb: FormBuilder,
    private _otSv: OtService,
    private _cmSv: ComunicacionService,
    private _accesorioSv: AccesorioService,
    private _productoSv: ProductoService,
    private _caracteristicaSv: CaracteristicaService,
    private _permisoSv: PermisoService,
  ) { }

  ngOnInit() {
    if (!this._data) {
      throw "La variable Input '_data' es requerida";
    }
    if (!this._data.tipoABM) {
      throw "La variable Input 'tipoABM' es requerida";
    }
    if (!this._data.model) {
      throw "La variable Input 'model' es requerida";
    }
    if (!this._data.titulo) {
      throw "La variable Input 'titulo' es requerida";
    }

    this._prepararForm();
  }

  ngAfterViewInit(): void {
    this._permisoSv.tienePermiso('ORDEN-TRABAJO-ELIMINAR-ARCHIVOS').then(
      (tienePermiso) => {
        if (tienePermiso && this.downloader) {
          this.downloader.removibles = true;
        }
      }
    );
  }

  private _prepararForm() {
    this.tipoABM = this._data.tipoABM;
    this.model = this._data.model;
    this.titulo = this._data.titulo;
    this.cargando = [];

    switch (this.tipoABM) {
      case this.TipoABM.ALTA:
        this._prepararAlta();
        break;
      case this.TipoABM.MODIFICACION:
        this._prepararModificacion();
        break;
    }

    // si cambia el selector de tipo de producto 
    this.form.get('especial').valueChanges.subscribe(() => {
      // limpiar tanto el selector como el valor seleccionado
      this._ngSelectProducto.clearModel();
      // traer los productos que corresponden
      this._traerProductos();
      // clear array de caracteristicas
      this._traerCaracteristicas();
    });

    // traer productos para el selector de productos
    this._traerProductos();
    this._traerCaracteristicas();
  }

  private _prepararAlta() {
    this.tipoForm = this.TipoForm.CREAR;
  }

  private _prepararModificacion() {
    this.tipoForm = this.TipoForm.EDITAR;
    this.form.get('id').setValue(this.model.id);
    this.form.get('numero').setValue(this.model.numero);
    this.form.get('especial').setValue(!!+this.model.producto.ProductoEspecial);
    this.form.get('especial').disable();
    this.form.get('fecha_vigencia').setValue(this.model.fecha_vigencia);
    this.form.get('fecha_entrega').setValue(this.model.fecha_entrega);
    this.form.get('archivos').setValue(this.model.archivos);
    this.form.get('pdtg_archivo_id').setValue(this.model.pdtg_archivo);
    this.form.get('especificacion_tecnica_archivo_id').setValue(this.model.especificacion_tecnica_archivo);
    this.form.get('esquema_dimensiones_archivo_id').setValue(this.model.esquema_dimensiones_archivo);
    this._ngSelectProducto.setDisabledState(true);
    this.form.get('producto_descripcion').setValue(this.model.producto_descripcion);
    this.form.get('cantidad').setValue(this.model.detalles.length);
    this.form.get('cantidad').disable();
    this.form.get('CUT').setValue(this.model.CUT);
    this.form.get('revision').setValue(this.model.revision);
    this.form.get('multas').setValue(!!+this.model.multas);
  }

  private _traerCaracteristicas() {
    this.cargando.push(true);
    this._caracteristicaSv.getCaracteristicas().subscribe(
      respuesta => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.form.controls.caracteristicas = this._fb.array(data.map(caracteristica => {
            let valor = null;
            // si es especial se puede asignar un valor a las características, si no se pone en null
            if (this.model && this.model.caracteristicas && this.form.get('especial').value) {
              const c_buscada = this.model.caracteristicas.find(x => x.caracteristica_id == caracteristica.IdCaracteristica);
              if (c_buscada && typeof c_buscada.valor != 'undefined') {
                valor = c_buscada.valor;
              }
            }
            const group = this._fb.group({
              caracteristica_id: [caracteristica.IdCaracteristica],
              valor: [valor],
              model: [caracteristica]
            });
            return group;
          }));
        }
      },
      () => {
        this.cargando.pop();
      }
    );
  }

  private _traerProductos() {
    this.productos = [];
    this.cargando.push(true);
    this._productoSv.getProductos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        especial: this.form.controls.especial.value
      }
    ).subscribe(
      (respuesta) => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.productos = data.productos;
          if (this.tipoABM == this.TipoABM.MODIFICACION) {
            this.producto_id = this.model.producto_id;
          }
        }
      },
      () => {
        this.cargando.pop();
      });
  }

  private _traerAccesorios() {
    if (this.form.controls.producto.value) {
      this.cargando.push(true);
      this._accesorioSv.getAccesorios({
        page: null,
        pageSize: null
      },
        {
          sort: 'descripcion',
          order: 'asc'
        },
        {
          IdTipoProducto: this.form.controls.producto.value.tipo.id
        }
      ).subscribe(
        (respuesta) => {
          this.cargando.pop();
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.form.controls.accesorios = this._fb.array(data.accesorios.map((accesorio) => {
              let seleccionado = false;
              let cantidad = null;
              // en la edición seteamos los valores que vienen del sv
              if (this.tipoABM == this.TipoABM.MODIFICACION) {
                const accesorio_seleccionado = this.model.accesorios.find(acc => acc.accesorio_id == accesorio.IdAccesorio);
                seleccionado = accesorio_seleccionado != undefined;
                if (seleccionado)
                  cantidad = accesorio_seleccionado.cantidad;
              }
              const group = this._fb.group({
                id: [accesorio.IdAccesorio],
                descripcion: [accesorio.descripcion],
                cantidad: [{
                  value: cantidad,
                  disabled: !seleccionado,
                }],
                seleccionado: [seleccionado]
              });
              // la cantidad se puede setear si el accesorio fue seleccionado
              group.get('seleccionado').valueChanges.subscribe((seleccionado) => {
                const cantidad_control = group.get('cantidad');
                cantidad_control.setValue(null);
                if (seleccionado) {
                  cantidad_control.enable();
                } else {
                  cantidad_control.disable();
                }
              });
              return group;
            }));
          }
        },
        () => {
          this.cargando.pop();
        }
      );
    }
  }

  dismiss() {
    this._dialogRef.close();
  }

  guardado_correctamente: boolean = false;
  submit() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      // nos quedamos con los accesorios seleccionados
      const accesorios_seleccioandos =
        this.form.get('accesorios').value
          .filter(
            (accesorio) => accesorio.seleccionado)
          .map(
            (accesorio) => {
              if (accesorio.cantidad < 1 || isNaN(accesorio.cantidad))
                accesorio.cantidad = 1;
              return accesorio;
            });
      // guardar producto
      this.cargando.push(true);
      this._otSv.guardar(
        this.tipoABM,
        { ...this.form.getRawValue(), ...{ accesorios: accesorios_seleccioandos } }
      ).subscribe(
        (respuesta) => {
          this.cargando.pop();
          const data = this._cmSv.format(respuesta, true);
          if (data != this._cmSv.SIN_DATA) {
            this.guardado_correctamente = true;
            // al guardar nos devuelve el id
            this.form.controls.id.setValue(data.id);
            // con el ID subimos los archivos (si los hay)
            this.uploader.uploadAll().subscribe(
              (allUploaded) => {
                if (allUploaded) {
                  this.uploaderPDTG.uploadAll().subscribe(
                    (pdtgUploaded) => {
                      if (pdtgUploaded) {
                        this.uploaderEspecificacionTecnica.uploadAll().subscribe(
                          (especificacionTecnicaUploaded) => {
                            if (especificacionTecnicaUploaded) {
                              this.uploaderEsquemaDimensiones.uploadAll().subscribe(
                                (esquemaDimensionesUploaded) => {
                                  if (esquemaDimensionesUploaded) {
                                    this._dialogRef.close(this.form.getRawValue());
                                  }
                                }
                              );
                            }
                          }
                        );
                      }
                    }
                  );
                } else {
                  // movemos los archivos que si fueron cargados a cargados 
                  // y los removemos de los archivos para cargar
                  this.uploader.getUploadedFiles().forEach((uploadedFile) => {
                    let files = this.form.get('archivos').value;
                    files.push(uploadedFile.data);
                    this.form.get('archivos').setValue(files);
                    this.uploader.remove(uploadedFile);
                  });
                }
              });
          }
        },
        () => {
          this.cargando.pop();
        }
      );
    }
  }

  comprarValor = (a, b) => {
    return a == b;
  }
}
